<template>
  <CalculationElementLayout
    :child-elements="['variant']"
    :node-id="nodeId">
    <v-container>
      <v-row>
        <v-col>
          <v-tabs
            v-model="tab"
            align-tabs="start"
            color="#0F6DAC"
            density="compact"
            slider-color="primary">
            <v-tab
              class="text-none text-subtitle-1 text-capitalize"
              prepend-icon="mdi-pencil"
              :value="'variants'"
              variant="text">
              {{ $t("entities.variant.multiple") }}
            </v-tab>

            <v-tab
              class="text-none text-subtitle-1 text-capitalize"
              prepend-icon="mdi-eye"
              :value="'costs'">
              {{ $t("entities.variant.tabs.costBreakdown") }}
            </v-tab>
          </v-tabs>

          <v-window
            v-model="tab"
            style="overflow-x: scroll">
            <v-window-item
              :key="'variants'"
              :value="'variants'">
              <v-container fluid>
                <v-container fluid>
                  <variant-list
                    v-if="nodeId"
                    :part-id="nodeId" />
                </v-container>
              </v-container>
            </v-window-item>

            <v-window-item
              :key="'costs'"
              :value="'costs'">
              <v-container fluid>
                <v-container
                  fluid
                  style="overflow-x: auto">
                  <CostBreakdownTab
                    v-if="nodeId"
                    :key="nodeId"
                    kind="part"
                    :parent-id="nodeId" />
                </v-container>
              </v-container>
            </v-window-item>
          </v-window>
        </v-col>
      </v-row>
    </v-container>
  </CalculationElementLayout>
</template>

<script setup>
import { ref, computed } from "vue";
import { useTranslation } from "i18next-vue";
import { useRoute } from "vue-router";

import { useCommonRules } from "@/validations/common";

import VariantList from "./VariantsList.vue";
import CostBreakdownTab from "@/views/Calculations/shared/CostBreakdownTab.vue";
import ElementButtons from "@/components/Elements/ElementButtons.vue";
import CalculationElementLayout from "@/layouts/CalculationElementLayout.vue";

const { t } = useTranslation();
const route = useRoute();

const nodeId = computed(() => route.params.nodeId);

const valid = ref(false);
const tab = ref("variants");

// Form fields, only for validation

const { required } = useCommonRules(t);
</script>
